<template>
  <create-dialog
    width="50%"
    :title="title"
    @closeModal="$emit('closeModal', false)"
    @handleOpen="handleOpen"
    @validate="validateForm"
    ref="createDialog"
  >
    <template slot="form">
      <div class="row">
        <div class="col-md-7 col-lg-7 col-xl-5">
          <fg-input
            type="text"
            :label="`${$t('common_words.name')} *`"
            v-model="model.name"
            name="common_words.name"
            v-validate="modelValidations.name"
            :error="getError('common_words.name', true)"
            placeholder=" ..."
          >
          </fg-input>
        </div>
        <div class="col-md-5 col-lg-5 col-xl-2">
          <fg-input
            type="text"
            :label="`${$t('common_words.symbol')} *`"
            v-model="model.abbreviation"
            name="common_words.symbol"
            v-validate="modelValidations.abbreviation"
            :error="getError('common_words.symbol', true)"
            placeholder="..."
          >
          </fg-input>
        </div>
        <div
          :class="`${
            businesses.length > 2
              ? `col-md-5 col-lg-12 col-xl-5`
              : `col-md-12 col-xl-5`
          }`"
        >
          <div class="form-group has-label">
            <label for="">{{ $t('labor.unit_format') }}: *</label>
            <br />
            <el-select
              filterable
              class="select-primary mb-3 shadow-sm required-hour_type"
              v-model="model.data_formate"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                class="select-primary"
                v-for="item in dataFormate"
                :key="item.id + item.value"
                :label="item.value"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div v-if="businesses.length > 2" class="col-md-7 col-lg-12">
          <div class="form-group has-label">
            <label>{{ $t('common_words.companies2') }}: *</label>
            <br />
            <el-select
              collapse-tags
              @change="selectAllFromSelect('model.business_id', businesses)"
              clearable
              multiple
              filterable
              class="select-primary custom-width-select shadow-sm required-business"
              size="large"
              v-model="model.business_id"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="option in businesses"
                class="select-primary selected-all"
                :value="option.id"
                :label="option.name"
                :key="option.id"
              ></el-option>
            </el-select>
          </div>
        </div>
      </div>
    </template>
  </create-dialog>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util';
import MixinDialog from 'src/mixins/mixin-dialog';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinValidations from 'src/mixins/forms/mixin-validations';

export default {
  name: 'edit-or-create-unit',
  props: {
    syncDialog: {
      type: Object,
      default: () => {
        return { create: false, disabledField: false };
      },
    },
  },
  watch: {
    '$i18n.locale': ['getSelectAll'],
    syncDialog(newValue) {
      if (newValue.create) this.openModal('create', newValue.disabledField);
      else this.closeModal('create', newValue.disabledField);
    },
  },
  mixins: [MixinDialog, MixinForm, MixinPermissions, MixinValidations],
  data() {
    return {
      businesses: [],
      model: {
        name: null,
        abbreviation: null,
        data_formate: null,
        business_id: [],
        route: null,
      },
      modelValidations: {
        name: { required: true },
        abbreviation: { required: true },
      },
      dataFormate: [
        { id: 'entero', value: 'Entero' },
        { id: 'decimal', value: 'Decimal' },
      ],
    };
  },
  methods: {
    getSelectAll() {
      this.businesses = this.concatAll(this.businesses.splice(1));
    },
    handleOpen() {
      if (!this.model.isEdit) {
        this.model.business_id = this.selectElementsAsignFromModel(
          1,
          this.model.business_id,
          this.businesses
        );
      }
    },
    validateForm() {
      return this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          if (!isset(this.model.data_formate)) {
            return this.validationInputsRequired('hour_type');
          } else if (!isset(this.model.business_id)) {
            return this.validationInputsRequired('business');
          } else {
            this.$emit('addEdit', this.model);
            return true;
          }
        }
      });
    },
  },
  updated() {
    if (sessionStorage.getItem('editForm')) {
      const { id, name, abbreviation, data_formate, businesses } = JSON.parse(
        sessionStorage.getItem('editForm')
      );
      this.model = {
        id,
        name,
        abbreviation,
        data_formate,
        business_id: businesses.map((business) => business.id),
        isEdit: true,
      };
      this.errors.clear();
      sessionStorage.removeItem('editForm');
    }
  },
  created() {
    if (this.isIndex()) {
      Promise.all([Axios.getMasters('businesses/only')])
        .then((response) => {
          const [response_businesses] = response;
          this.businesses = this.concatAll(response_businesses.data.data);
        })
        .catch((error) => {
          this.showMessageErrors(error);
        });
    } else {
      this.showMessageAccess();
    }
  },
  beforeDestroy() {
    sessionStorage.removeItem('editForm');
    sessionStorage.removeItem('tableCode');
  },
};
</script>
